import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/node_modules/react-transition-group/esm/TransitionGroupContext.js
// module id = 2910
// module chunks = 0